import { Stack, Typography } from "@mui/material";
import { MarkdownRow } from "home/components/summary/markdownRow";
interface ITextFieldCardProps {
  id?: string;
  description: string;
  text?: string;
}
export const TextFieldCard = ({ id, description, text }: ITextFieldCardProps) => {
  if (!text) return null;
  return (
    <Stack>
      <Typography id={`${id}${description.toLowerCase()}-label`} variant="bodySubtextBold">
        {description}
      </Typography>
      <Typography id={`${id}${description.toLowerCase()}-text`} variant="bodyRegular">
        <MarkdownRow value={text} />
      </Typography>
    </Stack>
  );
};
